import styled from 'styled-components'
import BeforeAfter from '../../Create/components/HomeTitle/BeforeAfter'

const SectionWrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 80px 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`

const SectionContent = styled.div`
  width: 1200px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`

const SectionTitle = styled.h2`
  color: black;
  font-size: 48px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  text-align: center;
  text-transform: capitalize;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`

const SectionSubtitle = styled.p`
  color: #3f3f3f;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 900px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const ContentRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 30px;
  }
`

const ComparisonWrapper = styled.div`
  flex-shrink: 0;
  width: 720px;
  max-width: 100%;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 600px;
  }

  @media (max-width: 768px) {
    max-width: calc(100% - 40px);
  }
`

const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 500px;
  }

  @media (max-width: 768px) {
    gap: 8px;
    align-self: flex-start;
  }
`

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const CheckMark = styled.span`
  color: #ff5e6d;
  font-weight: 500;
`

const FeatureText = styled.span`
  color: black;
  font-weight: 500;
`

const ActionButton = styled.button`
  width: 322px;
  height: 50px;
  background: linear-gradient(270deg, #ff996e 0%, #ff5565 37%, #ff4576 75%, #ff5e84 100%);
  border: none;
  border-radius: 100px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 85, 101, 0.3);
  }

  @media (max-width: 768px) {
    width: 249px;
    height: 42px;
  }
`

const ButtonText = styled.span`
  color: white;
  font-size: 18px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

const features = [
  'Upload a photo of your real room',
  'Rearrange furniture with drag-and-drop tools',
  'Try new layouts, colors, and styles instantly',
  'Decorate with brand furniture and your own items',
  'Preview changes in augmented reality (AR)',
  'Save, compare, and share room designs'
]

const RealRoomSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <SectionContent>
        <SectionTitle>Design your real room with confidence.</SectionTitle>
        <SectionSubtitle>
          Decorate your actual home with tools made for real rooms. Upload a photo and instantly try
          new layouts, furniture, paint colors, and décor — all in one simple workspace.
        </SectionSubtitle>

        <ContentRow>
          <ComparisonWrapper>
            <BeforeAfter />
          </ComparisonWrapper>

          <FeaturesList>
            {features.map((feature, index) => (
              <FeatureItem key={index}>
                <CheckMark>✓</CheckMark>
                <FeatureText>{feature}</FeatureText>
              </FeatureItem>
            ))}
          </FeaturesList>
        </ContentRow>

        <ActionButton onClick={onActionClick}>
          <ButtonText>Start Designing Your Room</ButtonText>
        </ActionButton>
      </SectionContent>
    </SectionWrapper>
  )
}

export default RealRoomSection
